  <div *ngIf="fundraiser && miniStory && !readMoreStoryBtn && !isFundraiserEnded && (birthdayloader && qParams?.birthdaytime === '1' && qParams?.mini_story === '1') && userData" class="bdayloader">
    <img loading="lazy" [attr.data-src]="'../assets/images/confetti1.gif'" alt="" class="confettiimg">
    <div class="content">
      <img loading="lazy" [attr.data-src]="'../assets/images/bdaycake.png'" alt="">
      <div class="name">Hey {{userData?.full_name}},</div>
      <div class="wish">Happy Birthday!</div>
    </div>
  </div>
  <div class="mini-story">
    <app-mini-story *ngIf="fundraiser && miniStory && !readMoreStoryBtn && !isFundraiserEnded" [fundraiser]="fundraiser" (viewMore)="miniStory=$event;readMoreStoryBtn=true"></app-mini-story>
  </div>
  <section *ngIf="!miniStory" class="story-container" [ngClass]="{'no-margin': showEndCampaignPage}">
    <ng-container *ngIf="!showEndCampaignPage">
      <div class="sip-top-banner-wrapper">
        <app-sip-top-banner></app-sip-top-banner>
      </div>
    
      <!-- Fundraiser Ended label -->
      <app-end-fundraiser-banner *ngIf="fundraiser" [isFundraiserEnded]="isFundraiserEnded" [isSuccessfullyFunded]="isSuccessfullyFunded"
        [fundraiser]="fundraiser" [campaignUrl]="campaignUrl" [basicInfo]="basicInfo"
        [sharedCounts]="sharedCounts">
      </app-end-fundraiser-banner>
      <!-- Ended Fundraiser/Story Sip Banner -->
      <app-fundraiser-sipbanner *ngIf="isFundraiserEnded"
                              [config]="{
                                hideEndText: false,
                                hideDock: false,
                                info_3: 'ended',
                                queryParams: { utm_term: 'endedstory', utm_content: 'banner' }
                              }">
      </app-fundraiser-sipbanner>
      <!-- Thank you banner -->
      <app-thankyou-banner *ngIf="fundraiser" [fundraiser]="fundraiser" [isDonated]="isDonated" [donations]="donationCard"></app-thankyou-banner>
  
      <!-- Story_blur_image -->
      <div class="container blur-image-container" *ngIf="vwo.story_blur_image_ABC() === 'GLOBAL'">
        <div class="blur-image-content">
          <div class="blur-image-logo">
            <mat-icon class="strip-icon" *ngIf="vars.blur_image">visibility</mat-icon>
            <mat-icon class="strip-icon" *ngIf="!vars.blur_image">visibility_off</mat-icon>
          </div>
          <div class="blur-image-text">
            <strong>Hide sensitive photos</strong>
            <div>Blur all images on this page</div>
          </div>
        </div>
        <mat-slide-toggle [(ngModel)]="vars.blur_image" (change)="toggleBlur()"></mat-slide-toggle>
      </div>
      <!-- Urgent Banner -->
      <div class="container" *ngIf="!isSipStory && !userData?.aggdonationall?.funds && !isFundraiserEnded && hide_el" [ngClass]="{'banner-wrapper': isMobile, 'banner-wrapper-down':isMobile && vwo.story_blur_image_ABC() === 'GLOBAL'}">
        <ng-template [ngTemplateOutlet]="urgentBanner"></ng-template>
        <ng-template [ngTemplateOutlet]="taxBenefitRef" *ngIf="isMobile && fundraiser?.beneficiary?.tax_benefit"></ng-template>
      </div>
    
      <!-- Donor Impact/Save life notification -->
      <div *ngIf="!isSipStory && !isFundraiserEnded && !thankYouBanner && !vwo.quickDonate_fallback_p1_AB()">
        <ng-template [ngTemplateOutlet]="donorImpact"></ng-template>
      </div>
    
      <!-- sip Banner -->
      <div *ngIf="isSipStory && !isFundraiserEnded">
        <app-module-loader [load]="true" moduleId="sip-story-banner" selector="app-sip-story-banner"
                          [inputs]="{ config: { theme: 'v01' } }">
        </app-module-loader>
      </div>
    
      <!-- Banner v3 -->
      <!--Banner component-->
      <div class="dmsans">
        <app-banner  [fundraiser]="fundraiser" [theaterImg]="theaterImage" (watchVideo)="scrollToVideo($event)" [isFundraiserEnded]="isFundraiserEnded"></app-banner>
      </div>
    
      <div *ngIf="!fundraiser" class="container">
        <app-placeholder-loader type="story"></app-placeholder-loader>
      </div>
    
      <div id="story-container" class="container">
        <!-- Benficiary adn support card -->
        <div *ngIf="isMobile && hide_el && !vwo.story_variation_5()" class="row">
          <div class="col-sm-12 col-xs-12 support-card">
            <div class="bene-card">
              <app-benficiary-card *ngIf="fundraiser?.basicinfo" [fundraiser]="fundraiser" [sharyCard]="sharyCard"
                                  [basicInfo]="basicInfo" [beneficiary]="beneficiary" [donationCard]="donationCard" [isDonated]="isDonated"
                                  [tickrIsShown]="tickrIsShown" [currency]="currency" [isFundraiserEnded]="isFundraiserEnded" (watchVideo)="scrollToVideo($event)">
              </app-benficiary-card>
            </div>
          </div>
        </div>
        <!-- story variation 5 -->
         <app-component-loader [load]="vwo.story_variation_5() && isMobile && fundraiser?.basicinfo" selector="app-bene-hosp" [inputs]="{fundraiser, beneficiary}" />
        <!-- <ng-container *ngIf="vwo.story_variation_5() && isMobile && fundraiser?.basicinfo" [ngTemplateOutlet]="beneHospitalRef"></ng-container> -->
    
        <!-- story variation 5 ends -->
        <div class="row content-area">
          <div class="col-sm-12 col-xs-12 default-pad left-content-area" [ngClass]="{'col-lg-7 col-md-7': !(vars.showKCart && !isMobile), 'col-lg-8 col-md-8': vars.showKCart && !isMobile}">
    
            <div *ngIf="!isFundraiserEnded && vars.showKCart && isMobile" class="extra-products">
              <app-extra-product-select />
            </div>
    
            <!-- Story Tabs -->
            <app-story-tabs #tabs [fundraiser]="fundraiser" [updates]="updates" [isDonated]="isDonated" [sharedCounts]="sharedCounts"
              [isFundraiserEnded]="isFundraiserEnded" [campaingUrl]="campaignUrl" [basicinfo]="basicInfo" [currency]="currency"
              (tabIndex)="getTabIndex($event)" [hide_el]="hide_el">
            </app-story-tabs>
    
            <!-- sip pitch -->
            <div *ngIf="isSipStory && !isFundraiserEnded" class="sip-pitch">
              <app-module-loader [load]="true" moduleId="sip-story-pitch-card" selector="app-sip-story-pitch-card"></app-module-loader>
            </div>
    
            <!-- Video appealing -->
            <div *ngIf="fundraiser?.video_appeal" class="section-container">
              <div class="section-title"><span class="title-text">
                Watch this 10-second video appeal from {{beneficiary?.full_name}}’s family:
              </span></div>
              <div *ngIf="videoSrc" class="section-content">
                <!-- Youtube embed -->
                <iframe #youtubeEmbed class="video-container" type="text/html" [src]="videoSrc | safeUrl"></iframe>
              </div>
              {{videoSrc}}
            </div>
    
            <!-- Hospital/Doctor Contact -->
            <div *ngIf="fundraiser && hide_el" class="section-container">
              <div class="section-title"><span class="title-text">{{'Stories.contact.contact' | translatePipe | async}}</span></div>
              <div class="section-content">
                <app-hospital-doctor-contact [fundraiser]="fundraiser"></app-hospital-doctor-contact>
              </div>
            </div>
    
            <!-- Documents -->
            <div inViewport (inViewportAction)="inViewPortListner($event, 'docs')" *ngIf="checkLength(fundraiser?.viewmedicalbill) && tabIndex !== 1 && hide_el && (!isFundraiserEnded || vars?.fundraiser?.isDonated)" class="section-container">
              <div class="section-title"><span class="title-text">{{(vars.showKCart ? 'Stories.donations.extraProductDocs' : 'Stories.donations.medDocs') | translatePipe | async}}</span></div>
              <div *ngIf="inViewPort.docs" class="section-content">
                <app-story-docs [gallery]="fundraiser?.viewmedicalbill" [isMobile]="isMobile"></app-story-docs>
              </div>
            </div>
    
            <!-- Expenses -->
            <div inViewport (inViewportAction)="inViewPortListner($event, 'expense')" *ngIf="checkLength(fundraiser?.costbreakdown) && tabIndex !== 1 && hide_el" class="section-container">
              <div class="section-title"><span class="title-text">{{'Stories.expenses' | translatePipe | async}}</span></div>
              <div *ngIf="inViewPort.expense" class="section-content">
                <table class="expense-table">
                  <tr><th><strong>{{'Stories.typeexpense' | translatePipe | async}}</strong></th><th><strong>{{'Stories.amount' | translatePipe | async}}</strong></th></tr>
                  <tr *ngFor="let item of fundraiser?.costbreakdown">
                    <td [innerHTML]="item?.title"></td><td class="amount"><app-currency-icon [currency]="currency"></app-currency-icon>&nbsp;{{item?.amount | inrFormat:'INR'}}</td>
                  </tr>
                </table>
              </div>
            </div>
    
            <!-- <ng-template *ngIf="fundraiser?.doctor && (fundraiser.hospitallogo?.cdn_path || fundraiser.doctoravatar?.cdn_path) && !fundraiser?.non_medical && hide_el" [ngTemplateOutlet]="doctorInfoRef"></ng-template> -->
            <!-- Donation Methods -->
            <div inViewport (inViewportAction)="inViewPortListner($event, 'twitter')"></div>
            <div *ngIf="!isFundraiserEnded && currencyInfo?.currency=='INR' && vars.paymentOption && (fundraiser?.banktransfer?.info_3 || fundraiser?.settings?.show_qr)" class="section-container">
              <div class="section-title"><span class="title-text">{{ 'Stories.bankTransfer.donationMethods' | translatePipe | async}}</span></div>
              <div class="section-content">
                <app-donation-methods [donateBtnLabel]="'Contribute Now'" [fundraiser]="fundraiser" [bank]="fundraiser?.banktransfer" origin="s" [isSipStory]="isSipStory" [recommendTag]="false" [tagLabel]="''" [theme]="''">
                </app-donation-methods>
                <!--Refer a friend section-->
                <div *ngIf="hide_el" class="refer-friend">
                  <app-refer-friend></app-refer-friend>
                </div>
              </div>
            </div>
            <!-- Social Component -->
            <div class="social-container" *ngIf="isMobile && vars.social && !qParams?.hide_el?.match('2|3')">
              <ng-template [ngTemplateOutlet]="eminentTemp"></ng-template>
            </div>

            <div *ngIf="!isMobile && vars?.fundraiser?.is_multi_patient_campaign && vwo.multi_patient_note_AB()" class="multi-patient-info">
              <app-multi-patient-note theme="noPopover" />
            </div>

            <!-- Supporter's Comments -->
            <div *ngIf="hide_el" class="section-container">
              <div class="section-title">
                <span class="title-text">{{'Stories.referAFriend.supportersComments' | translatePipe | async}} <span *ngIf="checkLength(comments?.data)">({{comments?.total}})</span></span>
              </div>
              <!-- Comments card -->
              <div inViewport (inViewportAction)="inViewPortListner($event, 'comments')" class="section-content" id="supporter-comments">
                <app-module-loader [load]="inViewPort.comments" moduleId="comment-card" selector="app-comment-card" [inputs]="{comments: comments, origin: 'stories', postCommentLabel: ('Stories.referAFriend.writeSomethingToCheer' | translatePipe | async)+fundraiser?.campaigner?.fname, campaignId: fundraiser?.id, customTag: fundraiser?.custom_tag}"></app-module-loader>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-xs-12 default-pad right-content-area" [ngClass]="{'col-lg-5 col-md-5': !(vars.showKCart && !isMobile), 'col-lg-4 col-md-4': vars.showKCart && !isMobile}">
            <div *ngIf="!isMobile && !fundraiser?.settings?.nodonorlist && fundraiser?.parent_cause_id === 149" class="supporters">
              <app-supporters [fundraiser]="fundraiser" [myDonations]="donationCard" />
            </div>
            <div *ngIf="!isMobile && fundraiser?.parent_cause_id !== 149" class="support-card">
              <!-- View all supporters -->
              <div class="view-supporter" *ngIf="!isDonated && !isFundraiserEnded && !vars.showKCart">
                <app-view-supporters *ngIf="fundraiser?.raised?.beforeTickrBackers>10" [origin]="'stories'" [fundraiser]="fundraiser" [customTag]="customTag"
                  [settings]="fundraiser?.settings" [isFundraiserEnded]="isFundraiserEnded"
                  [donationCard]="donationCard" [isDonated]="isDonated" [tickrIsShown]="tickrIsShown">
                </app-view-supporters>
              </div>
              <!-- Donor card -->
              <app-support-card class="donor-card" *ngIf="donationCard && donationCard.length" [donations]="donationCard"
                cardType="donor" [campaingUrl]="campaignUrl" [fundraiser]="fundraiser">
              </app-support-card>
              <!--Sharee card -->
              <app-support-card class="donation-card" [donations]="sharyCard"
                  *ngIf="sharyCard && sharyCard.length" cardType="sharee">
              </app-support-card>
            </div>
    
            <div *ngIf="!isFundraiserEnded && vars.showKCart && !isMobile" class="extra-products payment-card">
              <app-extra-product-select />
            </div>
    
            <div *ngIf="!isFundraiserEnded && !(vars.showKCart && !isMobile)" [hidden]="isMobile" class="payment-card">
              <!--Beneficiary card-->
              <div *ngIf="hide_el" class="bene-card">
                <app-benficiary-card *ngIf="fundraiser?.basicinfo && !isSipStory" [fundraiser]="fundraiser"
                                    [basicInfo]="basicInfo" [beneficiary]="beneficiary" [isFundraiserEnded]="isFundraiserEnded"
                                    [donationCard]="donationCard" [isDonated]="!isDonated" [tickrIsShown]="tickrIsShown" (watchVideo)="scrollToVideo($event)"
                                    [type]="'v1'">
                </app-benficiary-card>
              </div>
              <h2 *ngIf="!isSipStory && !vars.selectedKCart" [style.paddingTop]="'10px'">{{(donationTitle | translatePipe | async)}}</h2>
              <div *ngIf="isSipStory" class="sip-details">
                <app-module-loader [load]="true" moduleId="sip-story-banner" selector="app-sip-story-banner"
                                  [inputs]="{ config: { theme: 'v02' } }">
                </app-module-loader>
              </div>
              <app-main-payment *ngIf="fundraiser && (!isMobile || qParams?.st=='f')" [internal]="true" [fundraiser]="fundraiser" origin="s" [recommendTag]="false" [tagLabel]="''" [theme]="''" [showBeneficiary]="true" [type]="paymentDialogType" [onpage]="!isMobile" [captchaType]="isMobile ? 'dialog' : 'onpage'" [isSipStory]="isSipStory" [payment_config]="{mini_story: miniStory}"></app-main-payment>
            </div>
            <div *ngIf="isFundraiserEnded && !isMobile" class="ended-btn">
                <app-button class="app-button" type="button" label="Start a similar fundraiser"
                            btnClass="primary-btn" (click)="util.startSimilar(fundraiser, 'personal')">
                </app-button>
            </div>
          </div>
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 default-pad">
            <!-- Social Component -->
            <div class="social-container" *ngIf="!isMobile && vars.social && !qParams?.hide_el?.match('2|3')" inViewport (inViewportAction)="inViewPortListner($event, 'twitter')">
              <ng-template [ngTemplateOutlet]="eminentTemp"></ng-template>
            </div>
            <!-- FAQs component -->
            <div *ngIf="hide_el" class="section-container">
              <div class="section-title"><span class="title-text">{{'Stories.faq' | translatePipe | async}}</span></div>
              <div class="section-content">
                <app-faqs [fundraiser]="fundraiser" [page]="fundraiser?.non_medical ? 'non_medical' : 'story'" [beneficiary]="beneficiary?.full_name"></app-faqs>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    

    <app-ended-fundraiser-v2 #tabs *ngIf="fundraiser && showEndCampaignPage && endedCampaignPageData && endedCampaignPageDataType && endedFundraiserTitle"
    [fundraiser]="fundraiser" [endedCampaignPageData]="endedCampaignPageData" [endedCampaignPageDataType]="endedCampaignPageDataType" [trendingFundraiserData]="trendingFundraiserData" [currency]="currency"
    [title]="endedFundraiserTitle" [subtitle]="endedFundraiserSubtitle"
    [pageType]="STORY"
    (goToFundraiserEvent)="handleGoToFundraiser()"
    (goToFundraiserUpdatesEvent)="handleGoToFundraiserUpdates()"
    [utmSource]="qParams.utm_source"
  ></app-ended-fundraiser-v2>
  </section>
  <!-- Story Footer -->
  <section *ngIf="!miniStory && !showEndCampaignPage" class="container-fluid">
    <div *ngIf="fundraiser && isFundraiserEnded && isMobile" class="fixed-button similar-btn">
      <app-button class="app-button" type="button" label="Start a similar fundraiser"
                  btnClass="primary-btn" (click)="util.startSimilar(fundraiser, 'personal')">
      </app-button>
    </div>
    <div *ngIf="fundraiser && !isFundraiserEnded && isMobile" id="dock-section" >
      <div id="urgentSlide" (scroll)="onWindowScroll()" class="urgent-slide">
        <span class="txt">{{getFirstName(beneficiary?.full_name)}} needs funds before {{fundraiser?.end_date | dayjs:'format':'Do MMM YY'}}</span>
        <span *ngIf="!fundraiser?.settings?.hidedaysleft" class="days-left">
          <i class="icon-stopwatch"></i>
          {{fundraiser?.end_date | dayjs:'diffInDays':1}} {{(fundraiser?.end_date | dayjs:'diffInDays':1) > 1 ? 'Days Left' : 'Day Left'}}
        </span>
      </div>
      <div class="fixed-button" *ngIf="!vwo.story_one_tap_AB() || vwo.quickDonate_fallback_p1_AB() !== 'v1' || vwo.quickDonate_fallback_p1_AB() !== 'v2' || !userData">
        <div *ngIf="vars?.fundraiser?.is_multi_patient_campaign && isMobile" class="mt-2">
          <app-multi-patient-note />
        </div>
        <app-donate-now [miniStory]="miniStory" [showLabel]="true" [label]="qParams?.hide_el?.match('2|3') ? 'Make a Contribution' : ('Stories.donations.makeDonation' | translatePipe |async)" [fundraiser]="fundraiser" [position]="9" [isSipStory]="isSipStory" [openDonate]="isMobile" [recommendTag]="false" [tagLabel]="''" [theme]="''"></app-donate-now>
      </div>
      <div *ngIf="vwo.quickDonate_fallback_p1_AB() === 'v1' && userData?.lastorder?.iso_currency === currency" class="fixed-button" [ngClass]="vwo.quickDonate_fallback_p1_AB() === 'v1' ? 'v1':''">
        <app-payment-otd [InputConfig]="{ label: 'Stories.donations.makeDonation' | translatePipe | async,  theme:'v1',  fundraiser: fundraiser, position: 9, docked: true, slabTheme: 'slab-theme-v5', paymentBtnClass: 'payment-btn-theme-v4', origin: 's', showSlabs: false, donatingAs: true, optionsCheck: false, onpage: true, donateBtnLabel:'Repeat contribution of', onAmtForm: false, showBeneficiary: true}"></app-payment-otd>
      </div>
      <app-payment-otd-btn *ngIf="vwo.story_one_tap_AB() && userData" [config]="{ label: 'Stories.donations.makeDonation' | translatePipe | async, fundraiser: fundraiser, position: 9, docked: true, slabTheme: 'slab-theme-v5', paymentBtnClass: 'payment-btn-theme-v3', origin: 's', showSlabs: true, donatingAs: true, optionsCheck: false, onpage: false}"></app-payment-otd-btn>
    </div>
  </section>

 
  
    <!-- About ketto and static component -->
    <div *ngIf="hide_el && vars.fundraiser && !miniStory" id="scroll-about-us" class="about-us" [ngClass]="{'no-margin': showEndCampaignPage}">
      <app-component-loader [load]="true" selector="app-about-domain"/>
    </div>
    <!-- Stroy footer -->
    <app-social-number *ngIf="!miniStory && hide_el"></app-social-number>
    <app-component-loader [load]="true" selector="testing" />
    <!-- Social share Overlay button -->
    <app-social-share-btn [ngClass]="{'d-sm-none': hide_el, 'float-top': userData && isMobile}" *ngIf="fundraiser && !miniStory" [fundraiser]="fundraiser" [basicInfo]="basicInfo" [isFundraiserEnded]="isFundraiserEnded"></app-social-share-btn>
    <div *ngIf="!hide_el" class="pb-5"></div>
  

<div *ngIf="loginPopupState" class="leadGenComp">
  <app-component-loader [load]="true" selector="app-lead-gen-phone"
    [inputs]="{
      showPopup: loginPopupState,
      title: 'Enter Phone Number to Proceed',
      subTitle: 'This story has sensitive information, enter your number to view the information'
    }"
    [outputs]="{onClose: leadGenClosed}"
  />
</div>

<!-- Donor Impact template -->
<ng-template #donorImpact>
  <div *ngIf="userData?.aggdonationall?.campaigns" class="container">
    <div class="row">
      <div class="donor-impact" matRipple>
        <div class="heart-txt">
          <div class="imapct-txt">
            <span class="txt">Welcome back <span class="text-capitalize">{{userData?.full_name.trim()}}</span>!</span>
            <span class="txt2"> Your previous contribution(s) helped save
              <span class="txt"> {{userData?.aggdonationall?.campaigns}} {{userData?.aggdonationall?.campaigns>1?'lives': 'life'}}</span>
              <span class="brk"> Keep doing the good work!</span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<!-- Urgent Banner Template -->
<ng-template #urgentBanner>
  <div class="urgent-banner-container" *ngIf="!isMobile">
    <div class="urgent-banner">
      <i class="material-icons">warning</i>
      <span class="urgent-txt">{{ (vars.showKCart ? 'Stories.extraProductTitle' : 'Stories.urgentNeedFunds') | translatePipe | async}}</span>
    </div>
  </div>
  <div class="urgent-v2-wrapper" *ngIf="isMobile">
    <div class="urgent-banner">
      <span class="urgent-txt">Urgent needs</span> 
      <span class="hr"> |</span>
      <div class="days-left" *ngIf="fundraiser?.end_date && !isFundraiserEnded && !fundraiser?.settings?.hidedaysleft">
        {{fundraiser?.end_date | dayjs:'diffInDays':1}}d left
      </div>
    </div>
  </div>
</ng-template>

<ng-template #taxBenefitRef>
  <div class="tax-benefit-wrapper">
    <div class="text">Tax benefit</div>
  </div>
</ng-template>

<!-- Doctor info wrapper -->
<ng-template #doctorInfoRef>
  <div class="doctor-info" *ngIf="fundraiser?.doctor?.info_1">
    <img loading="lazy" class="doctor-pic" [attr.data-src]="fundraiser.doctoravatar?.cdn_path ? fundraiser.doctoravatar?.cdn_path : fundraiser.hospitallogo?.cdn_path" alt="Doctor Profile Picture">
    <div class="doctor-details">
      <span class="assign">{{'Stories.donations.caseAssigned' | translatePipe | async}}</span>
      <span class="name">{{fundraiser.doctor?.info_1}}</span>
      <span class="hospital">{{fundraiser.hospital?.info_1}}</span>
    </div>
  </div>
</ng-template>


<ng-template #eminentTemp>
  <mat-expansion-panel #panel1 class="panel" [ngClass]="{'d-block': eminentVisible && !hide_el}" [expanded]="hide_el ? true : false" [disabled]="hide_el ? true : false" (expandedChange)="eminentExpand($event)" (afterExpand)="eminentEvent()">
    <mat-expansion-panel-header class="heading" collapsedHeight="38px" expandedHeight="38px">
      <mat-panel-title>{{'Stories.eminent' | translatePipe | async}}</mat-panel-title>
    </mat-expansion-panel-header>
    <div class="expanded">
      <app-social-strip [isMobile]="isMobile"></app-social-strip>
    </div>
  </mat-expansion-panel>
</ng-template>
